

import AddSubscribe from "modules/subscribe/share-app/modal/compenents/AddSubscribe.vue";
import NoChannels from "modules/subscribe/share-app/modal/compenents/NoChannels.vue";
import NoLogin from "modules/subscribe/share-app/modal/compenents/NoLogin.vue";
import {SubscribeKey} from "modules/subscribe/share-app/api/entity/SubscribeKey";
import {PropType} from "vue/dist/vue";
import {api} from "modules/subscribe/share-app/api";
import {GroupedChannels, Subscribe} from "modules/subscribe/share-app/api/entity/Subscribe";
import Success from "modules/subscribe/share-app/modal/compenents/Success.vue";
import UpdateSubscribe from "modules/subscribe/share-app/modal/compenents/UpdateSubscribe.vue";

export default {
    components: {UpdateSubscribe, Success, AddSubscribe, NoChannels, NoLogin},
    props: {
        subscribeKey: {
            type: Object as PropType<SubscribeKey>,
            require: true,
        },
        orgName: {
            type: String,
            require: true
        }
    },
    emits: ['update', 'close'],
    async mounted() {
        this.load = true;
        try {
            if (this.currentUser) {
                this.subscribe = await api.getSubscribe(this.subscribeKey);
                this.subscribeChannels = this.subscribe.subscribeChannels;
            }
        } catch (e) {
            console.warn(e)
        } finally {
            this.load = false;
        }
    },
    data() {
        let currentUser = (window as any).BaseApp.user;
        return {
            save: false,
            currentUser: currentUser,
            subscribeChannels: null as GroupedChannels,
            load: false,
            emailsCount: null,
            telegramsCount: null,
            openSuccessModal: false,
            subscribe:  null as Subscribe,
        };
    },
    methods: {
        hideModal(emailsCount, telegramsCount) {
            if (typeof emailsCount === 'number' && typeof telegramsCount === 'number') {
                this.emailsCount = emailsCount;
                this.telegramsCount = telegramsCount;
                this.openSuccessModal = true;
            } else {
                this.$emit('close', this.emailsCount, this.telegramsCount);
            }
        },
        hideSuccessModal() {
            this.openSuccessModal = false;
            this.close();
        },
        close() {
            this.$emit('close', this.emailsCount, this.telegramsCount);
        }
    },
};
